<template>
  <div class="mt-4">
    <div class="d-flex align-center justify-space-between ga-4">
      <v-skeleton-loader
        width="25%"
        height="172"
        type="image"
        class="card-skeleton-loader"
      />
      <v-skeleton-loader
        width="25%"
        height="172"
        type="image"
        class="card-skeleton-loader"
      />
      <v-skeleton-loader
        width="25%"
        height="172"
        type="image"
        class="card-skeleton-loader"
      />
      <v-skeleton-loader
        width="25%"
        height="172"
        type="image"
        class="card-skeleton-loader"
      />
    </div>
    <div class="mt-4">
      <div class="table-loader-wrapper">
        <p
          v-if="tableTitle"
          class="table-title"
        >
          {{ tableTitle }}
        </p>
        <v-skeleton-loader
          v-else
          width="200"
          type="heading"
        />
        <div class="table-loader-padding">
          <v-skeleton-loader
            width="100%"
            height="476"
            type="image"
            class="table-skeleton-loader"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionableInsightSkeletonLoader',
  props: {
    tableTitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.table-loader-wrapper {
  background-color: @white;
  border-radius: 10px;
  padding: 12px 0 24px;
}

.table-loader-padding {
  padding: 16px 24px;
}

.table-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  padding: 12px 24px;
}

:deep(.v-skeleton-loader) {
  border-radius: 10px;

  &.table-skeleton-loader .v-skeleton-loader__image {
    height: 476px;
    border-radius: 10px;
  }

  &.card-skeleton-loader .v-skeleton-loader__image {
    height: 172px;
    border-radius: 10px;
  }
}
</style>
